import { OneSecondInMillis } from '@racemap/utilities/consts/time';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useInterval } from './useInterval';

export function useCurrentDateTime(resolutionInMs = OneSecondInMillis): DateTime {
  const [dateTime, setDateTime] = useState(DateTime.now());
  useInterval(async () => {
    setDateTime(DateTime.now());
  }, resolutionInMs);

  return dateTime;
}
